<div #real draggable="true" (dragstart)="onDrag($event)" class="main" (mousedown)="onMouseDown($event)">
  <div class="grab-texture"></div>
</div>

<div #ghost class="ghost" [hidden]="!isMouseDown">
  <div class="grab-texture"></div>
</div>

<div *ngIf="isMouseDown" class="overlay"></div>
